import { ErrorHandler, inject, Injectable } from '@angular/core';

import { DatadogLogger } from '../vendor/datadog/datadog-logger';
import { DatadogRumService } from '../vendor/datadog/datadog-rum.service';

// Angular reports a bootstrap failure to the ErrorHandler and then rethrows it into
// `bootstrapApplication().catch`; the catch asks here so it reports only what we never saw.
let lastHandled: unknown;

export function wasHandledByErrorHandler(error: unknown): boolean {
  return error !== undefined && error === lastHandled;
}

/**
 * Angular `ErrorHandler` that reports unhandled exceptions to RUM and DD Logs (DEV-27946).
 * No `console.error`: the RUM SDK's console capture would turn it into a duplicate RUM error.
 */
@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private readonly rum = inject(DatadogRumService);
  private readonly logger = inject(DatadogLogger);

  handleError(error: unknown): void {
    lastHandled = error;
    if (isHttpFailure(error)) return;
    this.rum.addError(error, { source: 'angular' });
    this.logger.error({ message: 'unhandled_exception', error });
  }
}

// `httpErrorInterceptor` already logs these as `http_request_error`; keeping them out of RUM
// also keeps URLs with query strings and response bodies out of error messages.
function isHttpFailure(error: unknown): boolean {
  return (error as { name?: unknown } | null)?.name === 'HttpErrorResponse';
}
